module.exports = __webpack_public_path__ + "img/right.5697d517.png";